module.exports = __webpack_public_path__ + "static/media/esquizofrenia.48a9358b.png";